
import './App.css';
import Header from './components/Header';
import Cards from './components/Cards';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Cards></Cards>
      <Footer></Footer>
    </div>
  );
}

export default App;
